import { graphql } from "~/gql";

export const CURRENT_PDF_OPTIONS = graphql(/* GraphQL */ `
  query CurrentPdfOptions($outputDesignId: Float!) {
    currentPdfOptions(outputDesignId: $outputDesignId) {
      headerImageName
      footerImageName
      contentBeforeName
      contentAfterName
    }
  }
`);

export const DELETE_PDF_OPTION = graphql(/* GraphQL */ `
  mutation DeletePdfOption($option: String!, $outputDesignId: Float!) {
    deletePdfOption(option: $option, outputDesignId: $outputDesignId) {
      id
    }
  }
`);

export const UPLOAD_HEADER_IMAGE = graphql(/* GraphQL */ `
  mutation UploadHeaderImage($headerInput: HeaderInput!) {
    uploadHeaderImage(headerInput: $headerInput)
  }
`);

export const UPLOAD_FOOTER_IMAGE = graphql(/* GraphQL */ `
  mutation UploadFooterImage($footerInput: FooterInput!) {
    uploadFooterImage(footerInput: $footerInput)
  }
`);

export const UPLOAD_PDF_ATTACHMENT = graphql(/* GraphQL */ `
  mutation UploadPDFAttachment($pdfAttachment: PDFAttachment!) {
    uploadPDFAttachment(pdfAttachment: $pdfAttachment)
  }
`);
